/**
 * Stories implemented by ZillowNavbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent } from 'react';
import { HEADER_VERSIONS } from 'src/components/ZillowNavbar/constants';
import { UserNavigationData } from '../../types/UserNavigationData';
import { ZillowNavbarSections } from '../../../ZillowNavbarSections/ZillowNavbarSections';

export type Auth0AccountManagementProps = {
    onSignIn: () => void;
    onSignOut: () => void;
    /** Data for MyZillowDropdown, including user avatar and navigation links. */
    userNavigationData: UserNavigationData | null;
    // /** Used for testing, bound to data-testid if set */
    // testID?: string;
    zhlHost: string;
    version: HEADER_VERSIONS;
};

export const Auth0AccountManagement: FunctionComponent<Auth0AccountManagementProps> = ({
    onSignIn,
    onSignOut,
    userNavigationData,
    zhlHost,
    version,
}) => {
    if (!userNavigationData) {
        return (
            <ZillowNavbarSections
                onLinkClick={(_, event) => {
                    event.preventDefault();
                    onSignIn();
                }}
                links={{
                    sections: [
                        {
                            link: {
                                text: 'Sign in',
                                href: '#',
                            },
                        },
                    ],
                }}
                zhlHost={zhlHost}
                version={version}
            />
        );
    }

    return (
        <ZillowNavbarSections
            onLinkClick={(_, event) => {
                event.preventDefault();
                onSignOut();
            }}
            links={{
                sections: [
                    {
                        link: {
                            text: 'Sign out',
                            href: '#',
                        },
                    },
                ],
            }}
            zhlHost={zhlHost}
            version={version}
        />
    );
};
